/* eslint-disable @atlassian/tangerine/import/no-restricted-paths */
import type { PreloadedQuery } from 'react-relay';
import type { Match, RouteResource } from 'react-resource-router';

import { fg } from '@atlaskit/platform-feature-flags';
import {
	HubBootstrapWrapperQuery,
	type hubBootstrapWrapperQuery,
	mockHubRouteProps,
} from '@atlassian/company-hub-common';

import { HUB_PORTAL_PAGE_ROUTE_NAME, HUB_PREVIEW_ROUTE_NAME } from '../../controllers/constants';
import HubQuery, {
	type hubQuery as hubQueryType,
} from '../../ui/hub/__generated__/hubQuery.graphql';

import { createRelayResource, getPageAri } from './utils';

const getPageIdFromRouteParams = (match: Match, routeName?: string): string => {
	if (routeName === HUB_PORTAL_PAGE_ROUTE_NAME && fg('portal-pages-in-hub')) {
		const portalId = match.params.portalId;
		if (portalId) {
			return `portal_page-${portalId}`;
		}
	}
	return match.params.id || '';
};

export const hubBootstrapResource: RouteResource<
	PreloadedQuery<hubBootstrapWrapperQuery, Record<string, unknown>>
> = createRelayResource<hubBootstrapWrapperQuery>({
	getQuery: ({ match, route }, { cloudId, helpCenterAri }) => {
		const isPreview = route?.name === HUB_PREVIEW_ROUTE_NAME;
		const pageId = getPageIdFromRouteParams(match, route?.name);
		let cloudIdDerived = cloudId;
		let helpCenterAriDerived = helpCenterAri;

		if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
			cloudIdDerived = mockHubRouteProps.env.cloudId;
			helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
		}

		return {
			variables: {
				cloudId: cloudIdDerived,
				hubAri: helpCenterAriDerived,
				pageAri: getPageAri(helpCenterAriDerived, pageId),
				operationType: 'READ',
				hubEditMode: false,
			},
			query: HubBootstrapWrapperQuery,
			options: {
				fetchPolicy: 'store-or-network',
			},
		};
	},
});

export const hubPageResource: RouteResource<PreloadedQuery<hubQueryType, Record<string, unknown>>> =
	createRelayResource<hubQueryType>({
		getQuery: ({ match, route }, { cloudId, helpCenterAri }) => {
			const isPreview = route?.name === HUB_PREVIEW_ROUTE_NAME;
			const pageId = getPageIdFromRouteParams(match, route?.name);
			let cloudIdDerived = cloudId;
			let helpCenterAriDerived = helpCenterAri;

			if (isPreview && mockHubRouteProps.env.cloudId && mockHubRouteProps.env.helpCenterAri) {
				cloudIdDerived = mockHubRouteProps.env.cloudId;
				helpCenterAriDerived = mockHubRouteProps.env.helpCenterAri;
			}

			return {
				variables: {
					cloudId: cloudIdDerived,
					hubAri: helpCenterAriDerived,
					pageAri: getPageAri(helpCenterAriDerived, pageId),
				},
				query: HubQuery,
				options: {
					fetchPolicy: 'store-or-network',
				},
			};
		},
	});
